/**
 * Created by danielgw on 7/7/14.
 */
define(function (require) {

    var _ = require('underscore');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var LpAjaxTransport = require('lptransporter/lpajax');
    var PostmessageTransport = require('lptransporter/transports/postmessage');

    var BaseApiService = {
        /**
         * Creates a base instance for API Service
         *
         * @param args.domainUrl : The URL of the domain include HTTPS:// or http://.
         * @param args.serviceName : The name of the service for domain-lookup & logging purposes
         * @param args.postmessagePath : inner path to the /postmessage.min.html (optional)
         *
         * @returns An instance of a BaseApiService - with method createRequestObject
         */
        createInstance: function (args) {
            var baseApiService = null;
            var lastQueryParams = {};
            var defaultPollingTimeout = 10000;
            var isPolling = false;
            var pollingID;
            if (!args.postmessagePath) {
                args.postmessagePath = "";
            }
            // check if URL path available. If so create the iFrame using the URL + postmessagePath + postmessage file name
            if (args.domainUrl) {
                baseApiService = {
                    domainUrl: args.domainUrl,
                    serviceName: args.serviceName || ''
                };
                PostmessageTransport.configure({frames: [
                    { url: args.domainUrl + args.postmessagePath + "/postmessage.min.html", delayLoad: 0, maxReloadRetries: 500, reloadInterval: 10}
                ]});

            } else { // if no URL start domain-lookup according to serviceName and create the iFrame
                var serviceDomain;
                var apiResource = agentLEManager.getLEUrlResolverApiResourcesService(args.serviceName);
                if (apiResource) {
                    serviceDomain = agentLEManager.getLEUrlResolverGetUrl(apiResource);
                }

                baseApiService = {
                    domainUrl: serviceDomain,
                    serviceName: args.serviceName || ''
                };
                PostmessageTransport.configure({frames: [
                    { url: baseApiService.domainUrl + args.postmessagePath + "/postmessage.min.html", delayLoad: 0, maxReloadRetries: 500, reloadInterval: 10}
                ]});
            }

            baseApiService.revision = '0';
            baseApiService.revisionByArgs = {};

            checkLogServiceName(baseApiService);
            var logger = WebAgentLogger.getLogger('BaseApiService_' + baseApiService.serviceName);

            // if no serviceName provided - the last section of the URL will be used
            function checkLogServiceName(wrapper) {
                if (wrapper.serviceName === '') {
                    var start = wrapper.domainUrl.lastIndexOf('/') + 1;
                    if (start >= wrapper.domainUrl.length) {
                        start = 0;
                    }
                    var end = wrapper.domainUrl.indexOf('?');
                    if (end <= 0) {
                        end = wrapper.domainUrl.length;
                    }
                    wrapper.serviceName = wrapper.domainUrl.substring(start, end);
                }
            }

            /*
             Handle connection with the server
             ---------------------------------
             */
            //Method for running direct error callbacks supplied to functions
            function runErrorCallback(requestObj, data) {
                if (requestObj && requestObj.error) {
                    runCallback(requestObj.error, requestObj, data);
                }
                data = null;
                requestObj = null;
            }

            //Method for running direct success callbacks supplied to functions
            function runSuccessCallback(requestObj, data) {
                if (requestObj && requestObj.success) {
                    runCallback(requestObj.success, requestObj, data);
                }
                data = null;
                requestObj = null;
            }

            //Generic method for running callbacks
            function runCallback(callback, requestObj, data) {
                if (callback && typeof callback === 'function') {
                    try {
                        callback.apply(requestObj.context || requestObj, [data]);
                    } catch (err) {
                        logger.error("Failed to run callback " + err, requestObj.callingFunction);
                    }
                }
                callback = null;
                data = null;
                requestObj = null;
            }


            /*
             * createRequestObject(args) create the request object
             * @args contain the following fields:
             *  method - Optional. "GET", "POST" ... default: GET
             *  retries - Optional. default: 0
             *  timeout - Optional. default: 10000
             *  data -  Optional. An object containing additional query parameters for the request as mapped values.
             *  body - Optional. The body of the request.
             *  additionalUrl - Optional. Add section to the base URL  (example: baseurl= "https://domain.com/baseurl/"  additionalUrl= "search" => url = "https://domain.com/baseurl/search")
             *  callingFunction -
             *  success: Callback which will handle the returned data for a successful request.
             *  error: Callback which will handle a request that encountered an error.
             *  @usePolling - use the Polling process
             */

            function createRequestObject(args, usePolling) {
                var req = {};
                // set the defaults
                req.url = args.url || baseApiService.domainUrl;
                req.retries = 0;
                req.timeout = 10000;
                req.transportOrder = args.transportOrder || ["postmessage"];//["websocket2http" , "postmessage"]/******************Temporarily removing WebSockets until Batchelor issues are resolved ********/
                req.headers = {
                    AUTHORIZATION: 'Bearer ' + agentLEManager.getGlobLE(),
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                };
                // adding overriding for headers.
                _.merge(req.headers, args.headers);
                // This is for when we need to call an API that doesn't support If-Match headers.
                if (!args.noMatchHeader) {
                    if (args.splitRevisionBy) {
                        req.headers['If-Match'] = (baseApiService.revisionByArgs && baseApiService.revisionByArgs[args[args.splitRevisionBy]]) || '0';
                    } else {
                        req.headers['If-Match'] = baseApiService.revision;
                    }
                }
                req.method = "GET";
                if (args) {
                    if (args.data) {
                        req.data = args.data;
                    }
                    if (args.method) {
                        req.method = args.method;
                    }
                    if (args.body) {
                        req.body = args.body;
                    }
                    req.query = args.query || {};
                    req.query.NC = true;
                    if (args.retries) {
                        req.retries = args.retries;
                    }
                    if (args.timeout) {
                        req.timeout = args.timeout;
                    }
                    if (args.additionalUrl) {
                        req.url = req.url + args.additionalUrl;
                    }
                }
                req.success = function (data) {
                    logger.debug("", args.callingFunction, data);
                    if (data && data.headers) {
                        // If the response contains ac-revision we use it (nginx servers, Version 2 of AC service)
                        var acRevision = 'ac-revision';
                        if (typeof data.headers[acRevision] !== 'undefined') {
                            baseApiService.revision = data.headers[acRevision];
                            // If not, and there is an Etag - we use that (apache servers, Version 1 of AC services)
                        } else if (typeof data.headers.ETag !== 'undefined') {
                            baseApiService.revision = data.headers.ETag;
                        }
                        if (args.splitRevisionBy) {
                            baseApiService.revisionByArgs[args[args.splitRevisionBy]] = baseApiService.revision;
                        }
                        var lastModified = 'X-LP-Last-Modified';
                        if (typeof data.headers[lastModified] !== 'undefined') {
                            baseApiService.lastModified = data.headers[lastModified];
                        }
                    }
                    runSuccessCallback(args, data);
                    if (usePolling) {
                        scheduleNextPolling();
                    }
                    req = null;
                };
                req.error = function (errorData) {
                    logger.debug("", args.callingFunction, errorData);
                    runErrorCallback(args, errorData);
                    if (args.keepPollingOnError) {
                        scheduleNextPolling();
                    }
                    req = null;
                };
                return req;
            }

            // get the CurrentQuery
            function getCurrentQuery() {
                if (lastQueryParams.pollingCallback) {
                    lastQueryParams.pollingCallback(lastQueryParams);
                }
                return lastQueryParams;
            }

            // update the values of CurrentQuery
            function updateCurrentQuery(queryParams) {
                for (var key in queryParams) {
                    if (queryParams.hasOwnProperty(key)) {
                        lastQueryParams[key] = queryParams[key];
                    }
                }
            }

            /*
             *   Update the query of the Polling process
             */
            function scheduleNextPolling() {
                if (!isPolling) {
                    return;
                }
                if (pollingID) {
                    clearTimeout(pollingID);
                    pollingID = null;
                }
                pollingID = setTimeout(_startPolling, defaultPollingTimeout);
            }

            function _stopPolling() {
                if (pollingID) {
                    clearTimeout(pollingID);
                    pollingID = null;
                }
            }

            function _startPolling(reqObj) {
                if (reqObj) {
                    updateCurrentQuery(reqObj);
                }
                var requestObject = createRequestObject(getCurrentQuery(), true);
                LpAjaxTransport.issueCall(requestObject);
            }

            if (baseApiService) {
                /*
                 Create a new query request. Doesn't send or save the request in any way
                 @param args - (look at createRequestObject)
                 */
                baseApiService.createBasicRequest = function (args) {
                    return createRequestObject(args);
                };
                /*
                 Send a new query request regardless of the Polling process
                 @param args - (look at createRequestObject)
                 */
                baseApiService.sendRequest = function (args) {
                    if (args) {
                        if (args.polling) {
                            baseApiService.startPolling(args);
                        } else {
                            var requestObject = createRequestObject(args);
                            LpAjaxTransport.issueCall(requestObject);
                        }
                    }
                };
                /*
                 Send a new download request
                 @param args - (look at createRequestObject)
                 */
                baseApiService.sendDownloadRequest = function (args) {
                    if (args) {
                        args.transportOrder = ["filedownload"];
                        args.query = args.query || {};
                        args.query.access_token = agentLEManager.getGlobLE();
                        var requestObject = createRequestObject(args);
                        // filedownload.issueCall(requestObject);
                        LpAjaxTransport.issueCall(requestObject);
                    }
                };
                /*
                 start the polling process
                 @param args - (look at createRequestObject)
                 @param pollingTimeout - Set the timeout of the polling in milliseconds
                 */
                baseApiService.startPolling = function (args) {
                    if (args.pollingTimeout) {
                        defaultPollingTimeout = args.pollingTimeout;
                    }
                    if (args) {
                        _stopPolling();
                        isPolling = true;
                        _startPolling(args);
                    }
                };
                /*
                 Stop the polling process
                 */
                baseApiService.stopPolling = function () {
                    isPolling = false;
                    _stopPolling();
                };
                /*
                 Update the polling query
                 @param args - (look at createRequestObject)
                 @param SendImmediately - if true will send the request immediately
                 */
                baseApiService.updatePollingQuery = function (args, sendImmediately) {
                    if (args) {
                        updateCurrentQuery(args);
                        if (sendImmediately) {
                            _stopPolling();
                            _startPolling(args);
                        }
                    }
                };
            }
            return baseApiService;
        }
    };

    return BaseApiService;

});
